import React, {useEffect, useState} from 'react';
import {I18n} from 'react-redux-i18n';

import {useSelector} from 'react-redux';
import {EntityEditingCard} from '../index';

import {DataExportEditForm} from '../../containers/index';

import {ACCESS_RIGHTS} from '../../constants';
import {DataExportModel} from '../../types/DataExport';
import {isURLWithProtocol} from '../../utils/validators';

const rightAvailabilityMap = {
  buttonEdit: [ACCESS_RIGHTS.DATA_EXPORT_EDIT],
  buttonDelete: [ACCESS_RIGHTS.DATA_EXPORT_DELETE],
};

type DataExportDetailsProps = {
  isEditMode: boolean,
  dataExport: DataExportModel,
  handleClickButtonBack: () => void,
  handleClickButtonCancel: () => void,
  handleClickButtonDelete: () => void,
  handleClickButtonEdit: () => void,
  // eslint-disable-next-line no-unused-vars
  handleClickButtonSave: (formData: DataExportModel) => void,
}

function DataExportDetails({
  isEditMode,
  handleClickButtonBack,
  handleClickButtonCancel,
  handleClickButtonDelete,
  handleClickButtonEdit,
  handleClickButtonSave,
  dataExport,
}: DataExportDetailsProps) {
  const accountInfo = useSelector((store: any) => store.operatorLayoutReducer.accountInfo);
  const [formData, setFormData] = useState<DataExportModel>(() => ({
    ...dataExport,
  }));
  const [areSpecificFieldsValid, setAreSpecificFieldsValid] = useState(false);

  useEffect(() => {
    setFormData({
      ...dataExport,
    });
  }, [dataExport]);

  const isValidEntity =
    !!formData.name &&
    isURLWithProtocol(formData.collectorUrl) &&
    areSpecificFieldsValid &&
    (!accountInfo.organizationsAllowed ||
      formData.allOrgs ||
      formData.organizationIds.length > 0);

  return (
    <EntityEditingCard
      title={formData.name}
      entityType={I18n.t('entitiesTypes.dataExport')}
      isEditMode={isEditMode}
      isTherePathBack={true}
      isThereDeleteBlock={true}
      isThereEditBlock={true}
      handleClickButtonBack={handleClickButtonBack}
      handleClickButtonCancel={handleClickButtonCancel}
      handleClickButtonDelete={handleClickButtonDelete}
      handleClickButtonEdit={handleClickButtonEdit}
      handleClickButtonSave={() => handleClickButtonSave(formData)}
      customCardContentClass="card__content_policy"
      accessRights={rightAvailabilityMap}
      isValidEntity={isValidEntity}
      content={(
        <DataExportEditForm
          dataExport={formData}
          onFormChange={setFormData}
          setAreSpecificFieldsValid={setAreSpecificFieldsValid}
          isEditMode={isEditMode}
        />
      )}
    />
  );
}

export default DataExportDetails;
